import { HttpTypes } from '@/types';
import { ICollection, ICollectionData } from '@/types/collection';
import { AxiosInstance } from 'axios';

class Collections {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async list(queryParams: HttpTypes.FindParams): Promise<HttpTypes.IResponse<ICollection[]>> {
    const result = await this.client.get('/product/collection', {
      params: queryParams,
    });
    return result.data;
  }

  async detail(id: string): Promise<HttpTypes.IResponse<ICollectionData>> {
    const result = await this.client.get(`/product/collection/${id}`);
    return result.data;
  }

  async create(data: HttpTypes.AdminCollection): Promise<HttpTypes.IResponse<ICollection>> {
    const result = await this.client.post('/product/collection', data);
    return result.data;
  }

  async update(data: HttpTypes.AdminCollection): Promise<HttpTypes.IResponse<ICollection>> {
    const result = await this.client.put(`/product/collection/${data.collection_id}`, data);
    return result.data;
  }

  async delete(data: { ids: string[] }): Promise<HttpTypes.IResponse<ICollectionData>> {
    const result = await this.client.delete(`/product/collection/delete`, { data });
    return result.data;
  }

  async duplicate(
    name: string
  ): Promise<HttpTypes.IResponse<{ id: string; title: string }> | string> {
    const result = await this.client.get(`/product/collection/check-duplicate`, {
      params: { name },
    });

    return result.data;
  }

  async listOptions(
    queryParams: HttpTypes.FindParams
  ): Promise<HttpTypes.StoreCollectionListResponse> {
    const result = await this.client.get('/product/collection/options', {
      params: queryParams,
    });
    return result.data;
  }
}

export default Collections;
